module.exports = __webpack_public_path__ + "img/icon_map_11_on_011.dbd83bf7.png";